import useSWR from 'swr';
import { API_HOST } from '../helpers/constants';
import { fetcher } from '../utils';

export function useUser(id) {
  const url = `${API_HOST}/users/${id}`;

  const { data: responseData, error, isLoading, mutate } = useSWR(id ? url : null, fetcher);

  const revalidate = () => mutate(url);

  return {
    user: responseData,
    isLoading,
    isError: error,
    revalidate
  };
}
